import { FunctionComponent } from "react";

const EmptyAuthor: FunctionComponent = () => {
    return (
        <div>
            <p className="fst-italic fs-5">No Authors Listed Here</p>
        </div>
    );
}
export default EmptyAuthor;